export default function ContactCards() {
 
  const cards = [
    {
      image: "/img/contact-us/messageicon.svg",
      emoji: "💬",
      title: "Email Support",
      value: "support@soloconnect.com",
     
    },
    {
      image: "/img/contact-us/callicon.svg",
      emoji: "📞",
      gradient: "linear-gradient(135deg, #f472b6, #ec4899)",
      title: "Phone Support",
      value: "+91 9311146657",
      valueColor: "#7c3aed",
    },
    {
      image: "/img/contact-us/LocticianIcon.svg",
      emoji: "📍",
      gradient: "linear-gradient(135deg, #60a5fa, #3b82f6)",
      title: "Office Address",
      value: "Uttar Pradesh, India",
      valueColor: "#7c3aed",
    },
    {
      image: "/img/contact-us/ClockIcon.svg",
      emoji: "🕐",
     
      title: "Working Hours",
      value: "Mon - Sat",
      valueColor: "#7c3aed",
    },
  ];
 
  return (
    <section className="max-w-6xl mx-auto px-6 py-16">
      <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6">
        {cards.map((card) => (
          <div
            key={card.title}
            className="bg-white rounded-3xl border border-gray-100 shadow-sm hover:shadow-xl transition-all duration-300 hover:-translate-y-1 p-8 flex flex-col items-center text-center"
          >
            {/* Icon Box — image ya gradient emoji */}
            <div
              className="w-20 h-20 rounded-[22px] flex items-center justify-center mb-6 "
            //   style={{ background: card.gradient }}
            >
              {card.image ? (
                // ✅ Agar image set hai toh yeh dikhega
                <img
                  src={card.image}
                  alt={card.title}
                  className="w-15 h-15 object-contain"
                />
              ) : (
                // Placeholder — jab tak image nahi add karte
                <span className="text-3xl">{card.emoji}</span>
              )}
            </div>
 
            {/* Title */}
            <h3 className="font-bold text-gray-900 text-sm mb-1.5">
              {card.title}
            </h3>
 
            {/* Value */}
            <p
              className="font-semibold text-sm"
              style={{ color: card.valueColor }}
            >
              {card.value}
            </p>
          </div>
        ))}
      </div>
    </section>
  );
}